import React from "react";

import { CheckboxProps, Checkbox as MuiCheckbox } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import withStyles from "@mui/styles/withStyles";
import { checkboxClasses } from "@mui/material";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

import { cssAttributeValue, IStyles } from "../../../util/cssAttributeValue";

export const StyledCheckbox = withStyles({
  [`${checkboxClasses.root}`]: {
    border: "0",
    borderRadius: "4px",
  },
  [`${checkboxClasses.disabled}`]: {
    border: `1.5px solid ${colors.gray800}`,
  },
})((props: CheckboxProps) => <MuiCheckbox color="primary" {...props} />);

export const CheckboxWrapper = styled("div")(() => ({
  display: "flex",
  gap: 16,
}));

interface ICheckboxLabel {
  disabled?: boolean;
}

export const CheckboxLabel = styled("span", {
  shouldForwardProp(propName) {
    return propName !== "disabled";
  },
})(({ disabled }: ICheckboxLabel) => ({
  color: disabled ? colors.gray400 : colors.gray500,
  fontFamily: "Manrope",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: "0.25px",
}));

export const ContainerTooltipWithLabel = styled("div")({
  display: "flex",
  flexWrap: "wrap",
  gap: "16px",
  alignItems: "center",
});

export const IconInfoStyle = styled("div")(() => ({
  borderRadius: "100px",
  display: "flex",
  alignItems: "top",
  justifyContent: "center",
}));

const useStyles = makeStyles({
  root: {
    padding: "0",
    "&$checked": {
      border: 0,
      // Aware of the use of the variable, we change it when we use the new kit design
      color: colors.brandBlue500,
    },
    "&$disabled": {
      color: `${colors.gray400} !important`,
    },
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  disabled: {},
  checked: {},
  icon: {
    border: (props: IStyles) =>
      `1.5px solid ${cssAttributeValue({
        defaultValue: colors.gray500,
        disabled: props.disabled,
        error: props.error,
      })}`,
    borderRadius: 4,
    width: 14,
    height: 14,
    opacity: (props: IStyles) => (props.disabled ? 0.38 : 1),
  },
  checkedIcon: {
    backgroundColor: (props: IStyles) =>
      cssAttributeValue({ disabled: props.disabled, defaultValue: colors.brandBlue500 }),
    opacity: (props: IStyles) => (props.disabled ? 0.38 : 1),
    backgroundImage: "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
    borderRadius: 4,
    width: 14,
    height: 14,
    "&:before": {
      display: "block",
      padding: "0",
      width: 14,
      height: 14,
      backgroundImage:
        "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
        " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
        "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
      content: '""',
    },
    "input:hover ~ &": {
      backgroundColor: "#106ba3",
    },
  },
  controlLabel: {
    alignItems: "center",
    display: "flex",
    gap: 6,
    margin: 0,
  },
});

export default useStyles;
